export interface Tracking {
  title: string;
  description: string;
  date: string;
  pointId: number;
  alert: string | null;
}
export interface TrackingBaseData {
  trackingNumber: string;
  pickitNumber: string;
  tracking: Tracking[];
  title: string;
  statusTransaction: number;
  retailerName: string;
  transaction: {
    status: string;
    workflowTag: string;
    operationType: number;
    destination: any;
    origin: any;
    workflow: {
      tag: string;
    };
    logisticSolutionType: string;
    deliveryPromiseTime?: string;
  };
}

export type PointInfo = {
  name: string;
  latitude: number;
  longitude: number;
};

export type TrackingState = {
  trackingInfo: TrackingBaseData;
  isDirty: boolean;
  pickitCode: string;
  token?: string;
  pointInfo?: PointInfo;
};

export enum Status {
  Pending = 'pending',
  Live = 'live',
}
